import React from 'react';

function Loading(props) {

    return(
        <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    );

}

export default Loading;